<template>
  <div
    class="form-wrapper"
    :class="[requestSent && !loading && !success ? '--error-msg' : '']"
  >
    <transition name="error">
      <error v-if="requestSent && !loading && !success" :icon="iconNO"></error>
    </transition>
    <a
      v-if="requestSent && !loading && !success"
      class="form-wrapper__try-again-message"
      @click="tryAgain"
    >
      Try again
    </a>
    <loading v-if="loading"></loading>
    <transition name="success">
      <success v-if="requestSent && !loading && success"></success>
    </transition>
    <div v-if="!requestSent">
      <h2 class="form-wrapper__title">SIGN UP WITH</h2>
      <div class="form-wrapper__social-buttons">
        <social-login></social-login>
      </div>
      <horizontal-line-with-text-inside
        text="OR"
      ></horizontal-line-with-text-inside>

      <div class="form-wrapper__form">
        <form @submit.prevent="submit('REGISTER')" class="register-form">
          <div class="register-form__email">
            <input
              id="email"
              class="register-form__input"
              name="email"
              :class="{ '--error': submitted && errors.has('email') }"
              placeholder="Email"
              v-validate="'required|email'"
              v-model="form.email"
              type="text"
            />
            <p
              class="small-text--error small-text--left"
              v-if="submitted && errors.has('email')"
            >
              {{ errors.first("email") }}
            </p>
          </div>
          <div class="register-form__password">
            <input
              id="password"
              ref="password"
              class="register-form__input"
              name="password"
              :class="{ '--error': submitted && errors.has('password') }"
              v-validate="'required|min:7|verify_password'"
              v-model="form.password1"
              placeholder="Password"
              type="password"
            />
            <p
              class="small-text--error small-text--left"
              v-if="submitted && errors.has('password')"
            >
              {{ errors.first("password") }}
            </p>
          </div>
          <div class="register-form__pasword-confirmation">
            <input
              id="password-confirmation"
              class="register-form__input"
              placeholder="Password Confirmation"
              name="password_confirmation"
              :class="{
                '--error': submitted && errors.has('password_confirmation')
              }"
              v-validate="'required|confirmed:password'"
              v-model="form.password2"
              type="password"
            />
            <p
              class="small-text--error small-text--left"
              v-if="submitted && errors.has('password_confirmation')"
            >
              {{ errors.first("password_confirmation") }}
            </p>
          </div>

          <div>
            <privacy-policy></privacy-policy>
            <button
              :style="{ border: 'none' }"
              id="register-button"
              class="register-form__button"
              type="submit"
            >
              SIGNUP
            </button>
          </div>
        </form>
        <div class="toggle-switch" @click="toggleOption">
          Have an account?
          <span
            :style="{
              color: '#0f74bd',
              'font-size': '18px',
              'font-weight': 'bold',
              'margin-left': '8px'
            }"
          >
            SIGNIN</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrivacyPolicy from "./info/privacy-policy";
import Modal from "./modal/modal.vue";
import Error from "./info/statuses/error";
import Loading from "./info/statuses/loading";
import Success from "./info/statuses/success";
import Form from "./utils/form.js";
import Login from "./utils/login";
import SocialLogin from "./social-login";
import HorizontalLineWithTextInside from "./horizontal-line-with-text-inside";
import { mapGetters } from "vuex";

export default {
  name: "register-form",
  mixins: [Login, Form],
  components: {
    PrivacyPolicy,
    Modal,
    SocialLogin,
    HorizontalLineWithTextInside,
    Error,
    Loading,
    Success
  },
  data: function() {
    return {
      signUp: null,
      submitted: false,
      signUpSet: false,
      form: {
        username: "",
        email: "",
        password1: "",
        password2: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      isSignUp: "SsoLogin/isSignUp",
      isSignUpSet: "SsoLogin/isSignUpSet"
    })
  },
  methods: {
    setValues: function() {
      return {
        username: "",
        email: "",
        password1: "",
        password2: ""
      };
    },
    toggleOption() {
      // console.log(this.isSignUp, this.isSignUpSet, "asjdnaksjdb");
      // this.signUp = !this.signUp;
      this.$store.commit("SsoLogin/setSignUp", !this.isSignUp);
      this.signUp = this.isSignUp;
      setTimeout(() => {
        // this.signUp ? (this.signUpSet = true) : (this.signUpSet = false);
        !this.isSignUp
          ? this.$store.commit("SsoLogin/setSignUpSet", false)
          : this.$store.commit("SsoLogin/setSignUpSet", true);

        this.signUpSet = this.isSignUpSet;
      }, 100);

      // console.log(
      //   this.isSignUp,
      //   this.isSignUpSet,

      //   this.signUp,
      //   this.signUpSet,
      //   "after change"
      // );
    }
  }
};
</script>

<style lang="scss">
.error-enter-active {
  animation: error-in 0.5s;
}

@keyframes error-in {
  0% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}

.success-enter-active {
  animation: success-in 0.5s;
}

@keyframes success-in {
  from {
    width: 80px;
    height: 80px !important;
    border-radius: 50%;
  }
  to {
    width: 200px;
    height: 80px;
    border-radius: 10%;
  }
}

.form-wrapper {
  // height: 100%;
  display: flex;
  align-items: center;
  min-height: 100vh;
  &.--error-msg {
    flex-direction: column;
    justify-content: center;
    align-content: center;
  }

  &__try-again-message {
    cursor: pointer;
    margin-top: 1rem;
  }

  &.--error {
    color: red;
  }
  &__form {
    width: 100%;
  }
  &__title {
    color: #333333;
    font-size: 36px;
    font-weight: bold;
    margin-top: 30px;
  }

  .register-form {
    a {
      // color: #0f74bd;
      color: #2A71D4 !important;
    }

    &__input {
      margin: 1rem 0;
      height: 45px;
      width: 100%;
      border: 1px solid #dddddd;
      background-color: #ffffff;
      border-radius: 10px;
    }

    &__button {
      height: 45px;
      width: 350px;
      // background-color: #0f74bd;
      background-color: #2A71D4;
      color: white;
      border-radius: 35px;
      /*margin-top: 2rem;*/
    }

    .small-text {
      &--error {
        color: red;
        font-size: 12px;
        margin: 5px;
      }
      &--left {
        text-align: left;
      }
    }
  }
}
.toggle-switch {
  @media screen and (max-width: 900px) {
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/register-form.vue